import Vue from 'vue'

import vuetify from './plugins/vuetify'
import './plugins/moment'
import './plugins/sentry'
import './plugins/filters'
import App from './App.vue'
import router from './router'
import store from './store'

import './styles/index.scss'

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
